import { Box, Divider } from '@mui/material';
import SparkHealthActions from './SparkHealthActions';
import { numericSort } from 'utilities/sort';
import type { SparkDiagnosticsMetaPublishChecklist } from 'types/Spark/SparkDiagnostics';
import SparkSectionHeader from '../SparkSectionHeader';

type RecommendedProps = {
  recommendedActions: SparkDiagnosticsMetaPublishChecklist['recommended'];
};

function Recommended({ recommendedActions }: RecommendedProps) {
  const sortedRecommendedActions = recommendedActions.sort((a, b) =>
    numericSort(a.sortOrder, b.sortOrder)
  );
  return (
    <Box>
      <Divider
        sx={{ width: '100%', marginBottom: '25px', marginTop: '25px' }}
      />
      <SparkSectionHeader
        headerText='Recommended'
        subHeaderText='Go the extra mile and add suggested information'
      />
      <SparkHealthActions
        actions={sortedRecommendedActions}
        containerStyles={{ ml: 2, mt: 2 }}
      />
    </Box>
  );
}

export default Recommended;
